import React from "react";
import {InputText} from 'primereact/inputtext';
import {Field} from "formik";

export default function NsFieldText({
                                        name,
                                        value = '',
                                        placeholder = '',
                                        formikRef,
                                        onChange = () => {
                                        },
                                        readOnly = false,
                                        isDisabled = false,
                                        isRequired = false,
                                        validate = () => {
                                        },
                                        type = 'text',
                                        isFormFieldInvalid,
                                    }) {

    return (
        formikRef && typeof formikRef !== "undefined" ?
            <Field
                name={name}
                component={InputText}
                className={"w-100"}
                onChange={(e) => {
                    if (formikRef) {
                        formikRef.current.setFieldValue(name, e.target.value);
                    }
                    onChange(e);
                }}
                readOnly={readOnly}
                required={isRequired}
                disabled={isDisabled}
                value={value}
                placeholder={placeholder}
                validate={validate}
                invalid={isFormFieldInvalid()}
                type={type}
            />
            :
            <InputText
                name={name}
                className={"w-100"}
                onChange={onChange}
                readOnly={readOnly}
                required={isRequired}
                disabled={isDisabled}
                value={value}
                placeholder={placeholder}
                invalid={isFormFieldInvalid()}
                type={type}
            />
    );
}